import { useRouter } from "next/router";

export default function usePublicPage() {
  const router = useRouter();
  const isPublicPage = [
    "/[user]",
    "/booking",
    "/cancel",
    "/reschedule",
    "/onboarding",
    "/customForm/[uid]",
  ].find((route) => router.pathname.startsWith(route));
  return isPublicPage;
}
